// extracted by mini-css-extract-plugin
export var baseButton = "_tx-0";
export var controlsArrowKeys = "_tx-1";
export var controlsResetButton = "_tx-2";
export var lightGameButton = "_tx-4 _tx-0";
export var playAgainButton = "_tx-5 _tx-0";
export var startGameButton = "_tx-3 _tx-0";